import { metaAccount } from '@/router/meta-config'
const permissionKey = 'FILE'

export default [
  // media-library
  {
    path: '/media-library',
    name: 'page-media-library',
    component: () => import('@/pages/media-library'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/file/new',
    name: 'page-file-new',
    component: () => import('@/pages/file'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/file/:id',
    name: 'page-file',
    component: () => import('@/pages/file'),
    props: (route) => ({ id: route.params.id }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
